module.exports = __webpack_public_path__ + "static/media/Richard M. Nixon (I) - 1972.66ff820f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/us/Richard M. Nixon (I) - 1972.jpg
// module id = 536
// module chunks = 0